import React from 'react';
import DOMPurify from 'dompurify';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import LocalizedLink from 'helpers/LocalizeLink';
import { useTranslation } from 'react-i18next';
import { getFormattedDuration, convert } from 'helpers/util';
import logo from 'assets/img/logo.svg';

const LearningListWidget = (props) => {
    const learning_link = 'learning/';
    const { t } = useTranslation();
    const auth = useSelector((store) => store.auth);
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    const getPublish = (item_data) => {
        let publishYear = new Date(item_data.updated_at).getFullYear();
        let publishMonth = new Date(item_data.updated_at).getMonth() - (currentYear - publishYear) * 12;
        return publishMonth > currentMonth ? 12 - publishMonth + currentMonth : currentMonth - publishMonth;
    };

    return (
        <div>
            {props.items.map((item, index) => {
                return (
                    <div key={'hl_' + index}>
                        <div>
                            <div>
                                <div>
                                    <div>
                                        {
                                            item.img ?
                                                <img alt={'learning'} src={item.img} /> :
                                                <img alt={'learning'} src={logo} />
                                        }
                                        <LocalizedLink to={learning_link + item.id}>
                                            <div>
                                                {
                                                    !auth ?
                                                        <p>{t('labels.lock')}</p> :

                                                        <p>{t('labels.learn')}</p>
                                                }
                                                <div></div>
                                            </div>
                                        </LocalizedLink>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <LocalizedLink to={learning_link && item && item.id ? learning_link + item.id : null}>
                                        <h3>{item.title}</h3>
                                    </LocalizedLink>
                                    <p>
                                        <span>
                                            {convert(item.views)} {t('labels.view_plural', { count: item.views })}
                                        </span> · <span>{getPublish(item)} {t('labels.month_ago', { count: getPublish(item) })}</span>
                                    </p>
                                    <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.description) }}></p>
                                    <div>
                                        {
                                            item.videos_duration > 0 ?
                                                <p>
                                                    {item.videos} {t('labels.video_plural', { count: item.videos })}
                                                    {" / "}
                                                    {getFormattedDuration(item.videos_duration)} {t('labels.complete')}
                                                </p> : null
                                        }
                                        {
                                            item.readings_duration > 0 ?
                                                <p>
                                                    {item.articles} {t('labels.article_plural', { count: item.articles })}
                                                    {" / "}
                                                    {getFormattedDuration(item.readings_duration)} {t('labels.complete')}
                                                </p> : null
                                        }
                                        <p className={'' + item.level}>
                                            {t('filter.labels.difficulty')}: {t(`filter.labels.${item.level}`)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>);

            })}
        </div>);

};

LearningListWidget.propTypes = {
    id: PropTypes.number,
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.string,
    position: PropTypes.number,
    widget: PropTypes.string,
    className: PropTypes.string,
    items: PropTypes.array,
    article_time: PropTypes.string,
    articles: PropTypes.string,
    video_time: PropTypes.string,
    videos: PropTypes.string
};

export default LearningListWidget;